import { usePage } from "@tecnobit-srl/router";
import { Grid } from "@tecnobit-srl/content-types-grid/lazy";
import { Skeleton } from "@tecnobit-srl/ui-skeleton";
import { jsx } from "react/jsx-runtime";
//#region src/related-courses-skeleton.tsx
/**
* The related-courses placeholder: as many card-shaped skeletons as the
* `relatedCoursesCount` the slim props carry, laid out on the same grid as the
* content, so the arriving cards do not move the surrounding layout. Covers both
* the block's code-chunk wait and its deferred-data wait.
*/
function RelatedCoursesSkeleton({ perRowDesktop = "4", perRowTablet = "2", perRowMobile = "1", xGapSize = "md", yGapSize = "md", align = "left", verticalStretch = false, childMinWidth }) {
	const { route: { routable = {} } } = usePage();
	const { relatedCoursesCount } = routable;
	return /* @__PURE__ */ jsx(Grid, {
		perRowDesktop,
		perRowTablet,
		perRowMobile,
		xGapSize,
		yGapSize,
		align,
		verticalStretch,
		childMinWidth,
		children: Array.from({ length: relatedCoursesCount ?? 4 }, (_, i) => /* @__PURE__ */ jsx(Skeleton, { css: {
			w: "full",
			h: "80",
			borderRadius: "md"
		} }, i))
	});
}
//#endregion
export { RelatedCoursesSkeleton as t };
